import { EnhancedModel } from '../enhanced.model';
import { Log } from '../../utils/log';
import { Utils } from '../../utils/utils';
import { JsonInterface } from '../json.interface';

export class Slot extends EnhancedModel implements JsonInterface {

    /**
     * "09:00"
     */
    private _slot:string = '00:00';
    public get slot():string {
        return this._slot;
    }
    public set slot(value:string) {
        this._slot = value;
    }

    private _slotMinute:number = 0;
    public get slotMinute():number {
        return this._slotMinute;
    }
    public set slotMinute(value:number) {
        this._slotMinute = value;
    }

    private _slotHour:number = 0;
    public get slotHour():number {
        return this._slotHour;
    }
    public set slotHour(value:number) {
        this._slotHour = value;
    }

    public get slotDisplayHour():number {
        if(this._slotHour > 12) {
            return this._slotHour - 12;
        } else if (this._slotHour === 0) {
            return 12;
        } else {
            return this._slotHour;
        }
    }

    public get slotDisplayMinute():string {
        if(this._slotMinute < 10) {
            return '0' + this._slotMinute.toString();
        } else {
            return this._slotMinute.toString();
        }
    }

    private _date:Date = new Date();
    public get date():Date {
        return this._date;
    }
    /**
     * Set on DaySlots
     */
    public set date(value:Date) {
        this._date = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 0, 0);
        this._date.setMinutes(this.slotMinute);
        this._date.setHours(this.slotHour);
        if(this._date.getTime() < Date.now()) {
            this.expired = true;
        }
    }

    private _available:number = 0;
    public get available():number {
        return this._available;
    }
    public set available(value:number) {
        this._available = value;
    }

    private _active:number = 0;
    public get active():number {
        return this._active;
    }
    public set active(value:number) {
        this._active = value;
    }

    private _total:number = 0;
    public get total():number {
        return this._total;
    }
    public set total(value:number) {
        this._total = value;
    }

    private _duration:number = 0;
    public get duration():number {
        return this._duration;
    }
    public set duration(value:number) {
        this._duration = value;
    }

    private _startTimestamp:string = '';
    public get startTimestamp():string {
        return this._startTimestamp;
    }
    public set startTimestamp(value:string) {
        this._startTimestamp = value;
    }

    private _endTimestamp:string = '';
    public get endTimestamp():string {
        return this._endTimestamp;
    }
    public set endTimestamp(value:string) {
        this._endTimestamp = value;
    }

    private _expired:boolean = false;
    public get expired():boolean {
        return this._expired;
    }
    public set expired(value:boolean) {
        this._expired = value;
    }

    constructor(obj: any = null) {
        super();
        if (obj !== null) {
            if (obj instanceof Slot) {
                this.mapClone(obj);
            } else {
                this.mapJson(obj);
            }
        }
    }

    /**
     * Only the fields that are specific to the service
     */
    public toJSON():any {
        let json:any = {};
        json.slot = this.slot;
        json.available = this.available;
        return json;
    }

    public clone() {
        let cloned = new Slot(this);
        return cloned;
    }

    protected mapClone(obj:Slot) {
        this.slot = obj.slot;
        this.available = obj.available;
        this.active = obj.active;
        this.total = obj.total;
        this.startTimestamp = obj.startTimestamp;
        this.duration = obj.duration;
        this.slotMinute = obj.slotMinute;
        this.slotHour = obj.slotHour;
        this.date = obj.date;
        this._endTimestamp = obj.endTimestamp;
    }

    protected mapJson(obj: any) {
        if (obj.hasOwnProperty('active')) {
            this.active = Number(obj.active);
            this.available = this.active;
        } else if (obj.hasOwnProperty('available')) {
            this.available = Number(obj.available);
            this.active = this.available;
        }
        if (obj.hasOwnProperty('total')) {
            this.total = Number(obj.total);
        }
        if (obj.hasOwnProperty('duration')) {
            this.duration = Number(obj.duration);
        }
        if (obj.hasOwnProperty('startTimestamp')) {
            // new
            this.setTimestamp(obj.startTimestamp);
        } else if (obj.hasOwnProperty('timestamp')){
            // legacy
            this.setTimestamp(obj.timestamp);
        }

    }

    private setTimestamp(timestamp:string){
        this.startTimestamp = timestamp + ":00"; // tack on seconds because service does not
        this._date = Utils.parseISOLocal(this.startTimestamp); // new Date(this.startTimestamp);
        let endDate:Date = new Date(this._date.getTime() + ((this.duration * 1000) * 60));
        this.endTimestamp = Utils.getLocalISOTimeDateString(endDate);
        this._slotMinute = this._date.getMinutes();
        this._slotHour = this._date.getHours();
        this._slot = this._slotHour + ':' + this.slotDisplayMinute;
        if (this._date.getTime() < Date.now()) {
            this._expired = true;
        }
    }

}
